import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EligibilityCheckComponent} from './eligibility-check.component';
import {EligibilityCheckRoutingModule} from './eligibility-check-routing.module';
import {EligibilityCheckFormComponent} from './eligibility-check-form/eligibility-check-form.component';
import {
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule
} from '@angular/material';
import {UserService} from '../../service/user.service';
import {PipesModule} from '../../utils/pipes/pipes.module';
import {OptionsComponent} from './options/options.component';
import {LoanDetailsService} from '../../service/loan-details.service';
import {UserAddressService} from '../../service/user-address.service';
import {CityDropdownModule} from '../../city-dropdown/city-dropdown.module';
import {OptionRowComponent} from './options/option-row/option-row.component';
import {PanValidatorComponent} from '../../common/pan-validator/pan-validator.component';
import {StateDropdownModule} from '../../state-dropdown/state-dropdown.module';
import {CreditAssessmentService} from '../../service/credit-assessment.service';
import {PhoneValidatorComponent} from './phone-validator/phone-validator.component';
import {SubventionPreferenceService} from '../../service/subvention-preference.service';
import {PanAlreadyPresentPromptComponent} from '../../common/pan-validator/pan-already-present-prompt/pan-already-present-prompt.component';
import {BrowserUtil} from '../../utils/browser.util';
import {LogoOnlyHeaderModule} from '../../headers/logo-only-header/logo-only-header.module';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {AdvanceEmiOptionsComponent} from './advance-emi-options/advance-emi-options.component';
import {AdvanceEmiOptionRowComponent} from './advance-emi-options/advance-emi-option-row/advance-emi-option-row.component';
import {PanAlreadyPresentPromptModule} from '../../common/pan-validator/pan-already-present-prompt/pan-already-present-prompt.module';

const materialImports = [MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDatepickerModule, MatButtonModule,
    ReactiveFormsModule, MatProgressSpinnerModule, MatDialogModule, MatSelectModule, MatExpansionModule];

@NgModule({
    imports: [FormsModule, CommonModule, CommonSectionsModule, EligibilityCheckRoutingModule, PipesModule, ...materialImports, StateDropdownModule,
        CityDropdownModule, LogoOnlyHeaderModule, PanAlreadyPresentPromptModule],
    declarations: [EligibilityCheckComponent, EligibilityCheckFormComponent, OptionsComponent, OptionRowComponent,
        PanValidatorComponent, PhoneValidatorComponent, AdvanceEmiOptionsComponent, AdvanceEmiOptionRowComponent],
    providers: [BrowserUtil, LoanDetailsService, SubventionPreferenceService, UserAddressService, UserService, CreditAssessmentService],
    entryComponents: [PanAlreadyPresentPromptComponent]
})
export class EligibilityCheckModule {
}
